/**
 * Operation Management Module - Mutation Services
 *
 * PUT hooks for MaintenanceTasks endpoints.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../../../services/useApi';
import { MAINTENANCE_TASK_DETAIL_URL, MAINTENANCE_TASKS_LIST_URL } from '../constants';
import type { IApiResponse, IUpdateMaintenanceTaskRequest } from '../types';

/**
 * Updates a maintenance task.
 * PUT /api/MaintenanceTasks/{requestId}
 */
export const useUpdateMaintenanceTask = () => {
  const { apiPrivate } = useApi();
  const queryClient = useQueryClient();

  return useMutation<IApiResponse, Error, { requestId: string; body: IUpdateMaintenanceTaskRequest }>({
    mutationFn: async ({ requestId, body }) => {
      const { data } = await apiPrivate.put(`${MAINTENANCE_TASK_DETAIL_URL}/${requestId}`, body);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MAINTENANCE_TASKS_LIST_URL] });
    },
  });
};
